import React from "react";

export function NotesSection({ notes, setNotes, t }) {
  return (
    <section className="flex flex-col gap-2">
      <label htmlFor="item-notes" className="text-sm font-bold text-dark">
        {t("Notes")}
      </label>
      <textarea
        id="item-notes"
        rows={2}
        className="w-full border-[1.5px] border-secondary-dark rounded-md px-4 py-3 text-base text-dark bg-surface placeholder:text-subtle resize-none focus:outline-none focus:border-primary transition-colors"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder={t("Add special instructions...")}
      />
    </section>
  );
}
